import { render, staticRenderFns } from "./SupportingDocuments.vue?vue&type=template&id=30a7f2d4&scoped=true&"
import script from "./SupportingDocuments.vue?vue&type=script&lang=ts&"
export * from "./SupportingDocuments.vue?vue&type=script&lang=ts&"
import style0 from "./SupportingDocuments.vue?vue&type=style&index=0&id=30a7f2d4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30a7f2d4",
  null
  
)

export default component.exports